import Vue from 'vue'
import axios from 'axios'
var URI = require('urijs');

export const advocacyVueApp = new Vue({
	el: '#advocacy-app',
	data: {
		types: [],
		allUpdates: [],
		updatesShown: [],
		numberOfUpdates: 0,
		numberOfUpdatesShown: 12,
		selectedUpdates: 'all',
		loading: true
	},
	delimiters: ['${', '}'],
	created: function() {
		this.getPosts();

	},

	methods: {
		filterUpdates(type) {
			this.selectedUpdates = type;
			this.getPosts();
		},

		showMore() {
			if (this.numberOfUpdatesShown < this.numberOfUpdates) {
				this.showMorePosts();
			}
		},

		getPosts() {
			var uri = new URI(window.location.href);
			var uriArray = uri.segment();
			var slug = uriArray.pop();

			if (slug == 'advocacy') {

				axios.get('/updates.json?&type='+this.selectedUpdates)
				.then(response => {

					this.allUpdates = response.data.data;
					this.numberOfUpdates = response.data.data.length;
					this.updatesShown = this.allUpdates.slice(0, (this.numberOfUpdatesShown));
					this.loading = false;

				});

			} else {

				axios.get('/updates.json?slug='+slug+'&type='+this.selectedUpdates)
				.then(response => {
					this.allUpdates = response.data.data;
					this.numberOfUpdates = response.data.data.length;
					this.updatesShown = this.allUpdates.slice(0, (this.numberOfUpdatesShown));
					this.loading = false;
				});

			}
		},

		showMorePosts() {
			this.numberOfUpdatesShown += 12;
			this.updatesShown = this.allUpdates.slice(0, (this.numberOfUpdatesShown));
		}
	}
});



// WEBPACK FOOTER //
// ./scripts/advocacy-vue-app.js